import { Fragment, useState, useEffect } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { API_URL } from '../Parametrizaciones.js';

function AdminTop() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Estado para autocompletar los campos con lo que hay en la BD
  const [codigos, setCodigos] = useState({
    codigo_1: "",
    codigo_2: "",
    codigo_3: "",
    codigo_4: "",
    codigo_5: "",
    codigo_6: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      setIsAuthenticated(true);
    } else {
      navigate('/controllers/Masterinc');
    }
  }, [navigate]);

  useEffect(() => {
    Modal.setAppElement("body");

    // Cargar códigos guardados actualmente en la base de datos
    fetch(`${API_URL}?action=obtenerCodigosTop`)
      .then((res) => {
        if (!res.ok) throw new Error("Error en la respuesta de la API");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setCodigos({
            codigo_1: data[0].codigo_1 || "",
            codigo_2: data[0].codigo_2 || "",
            codigo_3: data[0].codigo_3 || "",
            codigo_4: data[0].codigo_4 || "",
            codigo_5: data[0].codigo_5 || "",
            codigo_6: data[0].codigo_6 || "",
          });
        }
      })
      .catch((err) => {
        console.error("Error al obtener códigos top:", err);
      });
  }, []);

  const handleChange = (e) => {
    setCodigos({
      ...codigos,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${API_URL}?action=guardarCodigosTop`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(codigos),
      });

      const resJson = await response.json();

      if (response.ok) {
        alert(resJson.message || "Códigos Top actualizados correctamente.");
        navigate('/controllers/Masterinc');
      } else {
        alert("Error: " + (resJson.message || "No se pudo actualizar"));
      }

    } catch (err) {
      console.error("Error al guardar códigos Top:", err);
      alert("Ocurrió un error al intentar guardar los códigos Top.");
    }
  };

  if (!isAuthenticated) return null;

  return (
    <Fragment>
      <div className="aa-title">
        <div className="container">
          <br />
          <a href="/controllers/masterinc">
            <svg
              width="50"
              height="50"
              fill="currentColor"
              className="bi bi-house-fill"
              viewBox="0 0 16 16"
              style={{ color: "#59abe3" }}
            >
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
              <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
            </svg>
          </a>
          <h2>Administrar Top Imágenes</h2>
        </div>
        <br />

        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="container">
              <div className="panel-group" id="accordion">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h4 className="panel-title">
                      <a
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapse1"
                      >
                        Expandir | Administrar Top Propiedades
                      </a>
                    </h4>
                  </div>
                  <div id="collapse1" className="panel-collapse collapse in">
                    <div className="panel-body">
                      <br />
                      {[1, 2, 3, 4, 5, 6].map((num) => (
                        <div key={num} className="form-group col-md-4">
                          <input
                            type="text"
                            name={`codigo_${num}`}
                            value={codigos[`codigo_${num}`]}
                            onChange={handleChange}
                            className="form-control"
                            placeholder={`Código (Inmueble ${num})`}
                            maxLength="5"
                          />
                        </div>
                      ))}
                      <div className="col-md-12 text-center" style={{ marginTop: '15px' }}>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          style={{ height: "50px", width: "50%" }}
                        >
                          Actualizar Propiedades
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
}

export default AdminTop;